import {
  EAgentName,
  IChatApiRequest,
  IChatApiResponse,
} from '@/components/chatbot/ChatbotProvider';
import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export const useChat = (agentName: EAgentName) => {
  const sendChatMessage = async (
    message: string,
    sessionId: string,
    dynamicVariables: Record<string, string>,
  ) => {
    const body: IChatApiRequest = {
      message,
      agent_name: agentName.toLowerCase(),
      session_id: sessionId || '',
      dynamic_variables: dynamicVariables,
    };
    const url = `${getCoreApi()}/chat`;

    const response = await apiRequest<IChatApiResponse>(
      {
        url,
        method: 'POST',
        data: body,
      },
      true,
    );

    return response;
  };

  return {
    sendChatMessage,
  };
};
